module.exports = __webpack_public_path__ + "static/media/icon-prize-link.7327c381.png";